import { create } from 'zustand';
import dayjs from 'dayjs';

const initialPetState = {
  id: null,
  owners: [],
  name: '',
  race: null,
  pelage: null,
  gender: null,
  character: null,
  birthday: null,
  weight: '',
  chip: '',
  notes: '',
  death: false,
  image_url: null,
  thumb_url: null,
};

const usePetStore = create((set) => ({
  // Estado inicial
  pet: { ...initialPetState },

  // Acciones
  setPet: (pet) => set({ 
    pet: {
      ...pet,
      // Ensure Autocomplete fields are never undefined and birthday is properly formatted
      race: pet.race || null,
      pelage: pet.pelage || null,
      gender: pet.gender || null,
      character: pet.character || null,
      birthday: pet.birthday ? dayjs(pet.birthday) : null,
      owners: pet.owners || [],
    }
  }),

  // Acciones específicas
  updatePet: (updates) => set((state) => ({
    pet: { ...state.pet, ...updates }
  })),

  // Resetear pet
  resetPet: () => set({ pet: { ...initialPetState } }),

  // Acción específica para actualizar owners
  updatePetOwners: (owners) => set((state) => ({
    pet: { ...state.pet, owners }
  })),

  // Acción específica para actualizar birthday
  updatePetBirthday: (birthday) => set((state) => ({
    pet: { ...state.pet, birthday }
  })),

  // Acción específica para actualizar death status
  updatePetDeath: (death) => set((state) => ({
    pet: { ...state.pet, death: death ? 1 : 0 }
  })),
}));

export default usePetStore;
